import React, { useState, useEffect, useCallback } from "react";
import ClientsTable from "./tables/ClientsTable";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "../axios";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";

// import Autosuggest from 'react-autosuggest';

import { userLogout } from "../Actions";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import salcitLogo from "../Assets/images/Swaasa.png";
import logoutLogo from "../Assets/images/logout.png";
import ClipLoader from "react-spinners/ClipLoader";
import { bottomNavigationActionClasses } from "@mui/material";
import DoctorsTable from "./tables/DoctorsTable";
// import MenuIcon from '@mui/icons-material/Menu';
// import Slider from "@mui/material/Slider";

const ClientAdmin = (props) => {
  // var rowss = [];
  var patients = 0;
  var assessments = 0;
  const [pieData, setPieData] = useState([]);
  const [pieLabels, setPieLabels] = useState([]);
  const [total_patients, setTotal_patients] = useState();
  const [total_assessments, setTotal_assessments] = useState();
  const [total_doctors, setTotal_doctors] = useState();

  const [loading, setLoading] = useState(true);
  const [rowss, setRowss] = useState();
  const [userProps, setUserProps] = useState(props.match.params.clientId);
  const [datedata, setdateData] = useState(0);

  const [lastKey, setLastKey] = useState("");
  const [createdOn, setCreatedOn] = useState();
  const [records, setRecords] = useState();

  const [disabled, setdisabled] = useState(false);

  useEffect(() => {
    getDoctors();
  }, []);
  useEffect(() => {
    getProfile();
  }, []);

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayDate = yesterday.toISOString().slice(0, 10);

  const getDoctors = async (lastKey = "") => {
    const response = await axios.get(
      `/getDoctors?userId=${encodeURIComponent(
        props.match.params.clientId
      )}&last_e_key=${lastKey}&page_limit=100`,
      {
        headers: { accessToken: localStorage.accessToken },
      }
    );
    if (
      response.data.data &&
      response.data.data.users &&
      response.data.data.users.length > 0
    ) {
      setRowss(response.data.data.users);
    } else {
      setRowss([]);
    }
    setLastKey(response.data.last_key);
    var createdDate = response.data.createdOn;
    var date = new Date(createdDate);
    var formatedDate = date.toLocaleDateString();
    setCreatedOn(formatedDate);
    if (response.data.last_key === "e30=") {
      setdisabled(true);
    } else {
      setdisabled(false);
    }
    try {
      setPieData(Object.values(response.data.data.usageDict));
      setPieLabels(Object.keys(response.data.data.usageDict));
    } catch (e) {
      // console.log(e);
    }
    // rowss = await response.data.data.users;
    setLoading(false);
  };

  useEffect(() => {
    axios
      .get(
        `v2/admin/total_count?userId=${encodeURIComponent(
          props.match.params.clientId
        )}`,
        {
          headers: { accessToken: localStorage.accessToken },
        }
      )
      .then((response) => {
        console.log(response);
        setRecords(response.data.data.doc_count);

        setTotal_doctors(response.data.data.doc_count);
        console.log(response.data.data.doc_count);
        setTotal_assessments(response.data.data.total_assessments);
        setTotal_patients(response.data.data.patients_count);
        // setdateData(response.data.data.assessment_count);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  useEffect(() => {
    axios
      .get(
        `/getPatientsAssessments/${yesterdayDate} 00:00:00/${yesterdayDate} 23:59:59/${props.match.params.clientId}`,
        {
          headers: { accessToken: localStorage.accessToken },
        }
      )
      .then((response) => {
        setdateData(response.data.data.assessment_count);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const getProfile = () =>
    axios
      .get(`/getProfile/${props.match.params.clientId}`, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {
        console.log(response.data);
        // setFormData(response.data.data);

        // console.log("this issssssssssss", formData);
      })
      .catch((error) => {
        console.log(error);
      });
  const logout = () => {
    props.userLogout();
    localStorage.clear();
    props.history.push("/");
  };
  const [toggleState, setToggleState] = useState(1);
  const toggleTab = (index) => {
    setToggleState(index);
  };

  const [option1, setOption1] = useState("");
  const [option2, setOption2] = useState("");
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");

  const handleOption1Change = (event) => {
    setOption1(event.target.value);
  };

  const handleOption2Change = (event) => {
    setOption2(event.target.value);
  };

  const handleOption3Change = (event) => {
    setOption3(event.target.value);
  };

  const handleOption4Change = (event) => {
    setOption4(event.target.value);
  };
  if (loading) {
    return (
      <div className="loadingdiv">
        <ClipLoader color={"#fd8c00"} loading={loading} size={30} />
      </div>
    );
  } else {
    return (
      <div className="superAdmin">
        <Box sx={{ flexGrow: 1 }}>
          <AppBar
            position="static"
            sx={{ backgroundColor: "#f7f7f7", color: "black", marginBottom: 1 }}
          >
            <Toolbar>
              <Link to="/superadmin">
                <img className="superAdmin__logo" src={salcitLogo} alt="logo" />
              </Link>
              <Link to="/superadmin">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21 8.77217L14.0208 1.79299C12.8492 0.621414 10.9497 0.621413 9.77817 1.79299L3 8.57116V23.0858H10V17.0858C10 15.9812 10.8954 15.0858 12 15.0858C13.1046 15.0858 14 15.9812 14 17.0858V23.0858H21V8.77217ZM11.1924 3.2072L5 9.39959V21.0858H8V17.0858C8 14.8767 9.79086 13.0858 12 13.0858C14.2091 13.0858 16 14.8767 16 17.0858V21.0858H19V9.6006L12.6066 3.2072C12.2161 2.81668 11.5829 2.81668 11.1924 3.2072Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>

              <Typography
                variant="h5"
                component="div"
                sx={{ flexGrow: 2, marginTop: 1, fontSize: 18, paddingLeft: 1 }}
              >
                Super Admin
              </Typography>
              <Typography
                variant="p"
                component="div"
                sx={{
                  flexGrow: 0,
                  fontSize: 17,
                  borderRight: "solid 1px grey",
                }}
              >
                {localStorage.doctorId}&nbsp;&nbsp;&nbsp;
              </Typography>
              <Button
                color="inherit"
                sx={{
                  fontSize: 15,
                  textTransform: "none",
                  borderLeft: "black",
                }}
                onClick={() => {
                  logout();
                }}
              >
                {" "}
                <img
                  className="superAdmin__logout__logo"
                  src={logoutLogo}
                  alt="logo"
                />{" "}
                Log out
              </Button>
            </Toolbar>
          </AppBar>
        </Box>
        <div className="superAdmin__content">
          <div className="superAdmin__sideBar">
            <div className="superAdmin__usageCard">
              <h5 className="superAdmin__usageCard__heading">
                Welcome to Swaasa Admin Dashboard
              </h5>
              <p className="superAdmin__usageCard__heading">
                {props.match.params.clientName}
              </p>
              <div className="superAdmin__usageCard__container">
                <img
                  className="superAdmin__usageCard__clientlogo"
                  src={salcitLogo}
                  alt="logo"
                />
              </div>
              <p className="superAdmin__usageCard__created">
                Created On: {createdOn}
              </p>
              {/* <div className="superAdmin__usageCard__counts">
                <h2 className="superAdmin__usageCard__totalAssessments">
                  {total_doctors}
                </h2>
              </div>

              <div className="superAdmin__usageCard__names">
                <p className="superAdmin__usageCard__assessments">#doctors</p>
                <p className="superAdmin__usageCard__patients">
                #patients
            </p>
              </div> */}
            </div>
            <div className="superAdmin__piechart">
              <div className="bloc-tabs">
                <button
                  className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
                  onClick={() => toggleTab(1)}
                >
                  Quick Summary
                </button>
                <button
                  className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
                  onClick={() => toggleTab(2)}
                >
                  Configuration
                </button>
              </div>
              <div className="content-tabs">
                <div
                  className={
                    toggleState === 1 ? "content  active-content" : "content"
                  }
                >
                  {/* <h3 className="superAdmin__piechart__heading">Quick Analysis</h3> */}
                  <div className="superAdmin__piechart__content">
                    <div className="superAdmin__piechart__content__card1">
                      <p className="superAdmin__piechart__content__card1__heading">
                        Total Doctors
                      </p>
                      <p className="superAdmin__piechart__content__card1__counts">
                        {total_doctors}
                      </p>
                      <p className="superAdmin__piechart__content__card1__info">
                        {" "}
                        The number of doctors / health workers enrolled in this
                        organization.
                      </p>
                    </div>
                    <div className="superAdmin__piechart__content__card2">
                      <p className="superAdmin__piechart__content__card2__heading">
                        Total Patients
                      </p>
                      <p className="superAdmin__piechart__content__card2__counts">
                        {total_patients}
                      </p>
                      <p className="superAdmin__piechart__content__card2__info">
                        {" "}
                        Total number of patients that have been registered by
                        the doctors and health workers
                      </p>
                    </div>
                  </div>
                  <div className="superAdmin__piechart__content">
                    <div className="superAdmin__piechart__content__card3">
                      <p className="superAdmin__piechart__content__card3__heading">
                        Total Assessments
                      </p>
                      <p className="superAdmin__piechart__content__card3__counts">
                        {total_assessments}
                      </p>
                      <p className="superAdmin__piechart__content__card3__info">
                        {" "}
                        Cumulative total of assessments conducted by this
                        organization.
                      </p>
                    </div>
                    <div className="superAdmin__piechart__content__card4">
                      <p className="superAdmin__piechart__content__card4__heading">
                        Yesterday's Assessments
                      </p>
                      <p className="superAdmin__piechart__content__card4__counts">
                        {datedata}
                      </p>
                      <p className="superAdmin__piechart__content__card4__info">
                        {" "}
                        Total assessments that were done yesterday.
                      </p>
                    </div>
                  </div>
                </div>
                {/* the second tab starts here */}
                <div
                  className={
                    toggleState === 2 ? "content  active-content" : "content"
                  }
                >
                  {/* <div className="block">
                    <form>
                      <div>
                        <label htmlFor="dropdown1">Dropdown 1:</label>
                        <select
                          id="dropdown1"
                          value={option1}
                          onChange={handleOption1Change}
                        >
                          <option value="">Please select an option</option>
                          <option value="option1a">Option 1A</option>
                          <option value="option1b">Option 1B</option>
                          <option value="option1c">Option 1C</option>
                        </select>
                      </div>
                      <div>
                        <label htmlFor="dropdown2">Dropdown 2:</label>
                        <select
                          id="dropdown2"
                          value={option2}
                          onChange={handleOption2Change}
                        >
                          <option value="">Please select an option</option>
                          <option value="option2a">Option 2A</option>
                          <option value="option2b">Option 2B</option>
                          <option value="option2c">Option 2C</option>
                        </select>
                      </div>
                      <div>
                        <label htmlFor="dropdown3">Dropdown 3:</label>
                        <select
                          id="dropdown3"
                          value={option3}
                          onChange={handleOption3Change}
                        >
                          <option value="">Please select an option</option>
                          <option value="option3a">Option 3A</option>
                          <option value="option3b">Option 3B</option>
                          <option value="option3c">Option 3C</option>
                        </select>
                      </div>
                      <div>
                        <label htmlFor="dropdown4">Dropdown 4:</label>
                        <select
                          id="dropdown4"
                          value={option4}
                          onChange={handleOption4Change}
                        >
                          <option value="">Please select an option</option>
                          <option value="option4a">Option 4A</option>
                          <option value="option4b">Option 4B</option>
                          <option value="option4c">Option 4C</option>
                        </select>
                      </div>
                    </form>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="superAdmin__table">
            <h2 className="superAdmin__usageCard__ourclients">Doctors</h2>
            <DoctorsTable
              rows={rowss}
              lastKey={lastKey}
              userProps={userProps}
              records={records}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  doctors: state.doctors,
});
export default withRouter(
  connect(mapStateToProps, { userLogout })(ClientAdmin)
);
